// src/components/ads/AdSlot.jsx
import { useEffect } from "react";

export default function AdSlot({ slot, style }) {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.warn("AdSense push error:", e);
        }
    }, [slot]);

    return (
        <div className="adslot-wrapper">
            <ins
                className="adsbygoogle"
                style={style || { display: "block", textAlign: "center" }}
                data-ad-client="ca-pub-3219202769714805"
                data-ad-slot={slot}
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </div>
    );
}
